import { useTranslation } from '@eti/providers';
import {
  airHelp,
  allInclusiveProtection,
  baggageService,
  bankruptcyInsuranceCoverGenius,
  cabinBaggage,
  cancelForAnyReason,
  cancellationGuarantee,
  cancellationInsideEu,
  cancellationInsuranceCoverGenius,
  cancellationOutsideEu,
  checkInBaggage,
  climateCompensation,
  comprehensiveInsuranceCoverGenius,
  cancelTwentyFourHours,
  co2Compensation,
  fastTrack,
  flexibleTicket,
  meal,
  mobileTravelPlan,
  lounge,
  onlineCheckIn,
  qPass,
  seatMap,
  simpleVisa,
  sms,
  travelDocsPost,
  travelInsuranceCoverGenius,
  travelInsuranceInsideEu,
  travelInsuranceOutsideEu,
  tripCancellationProtection,
  platinum,
  airportTransfer,
} from '@eti/products';

export const useProductCartNames = () => {
  const { t } = useTranslation();

  return {
    [airHelp.name]: t('airHelpTitle'),
    [airportTransfer.name]: t('airportTransferTitle'),
    [allInclusiveProtection.name]: t('allInclusiveProtectionTitle'),
    [baggageService.name]: t('baggageServiceName'),
    [bankruptcyInsuranceCoverGenius.name]: t('bankruptcyInsuranceCoverGeniusTitle'),
    [cabinBaggage.name]: t('cabinBaggagePerTravelerTitle'),
    [cancelForAnyReason.name]: t('cancelForAnyReasonTitle'),
    [cancellationGuarantee.name]: t('cancellationGuaranteeTitle'),
    [cancellationInsideEu.name]: t('cancellationInsideEUTitle'),
    [cancellationInsuranceCoverGenius.name]: t('cancellationInsuranceCoverGeniusTitle'),
    [cancellationOutsideEu.name]: t('cancellationOutsideEUTitle'),
    [cancelTwentyFourHours.name]: t('cancelTwentyFourHoursTitle'),
    [checkInBaggage.name]: t('checkInBaggageHeaderTitle'),
    [climateCompensation.name]: t('climateCompensationTitle'),
    [comprehensiveInsuranceCoverGenius.name]: t('comprehensiveInsuranceCoverGeniusTitle'),
    [fastTrack.name]: t('fastTrackTitle'),
    [co2Compensation.name]: t('co2CompensationTitle'),
    [flexibleTicket.name]: t('flexibleTicketHeaderTitle'),
    [meal.name]: t('mealName'),
    [mobileTravelPlan.name]: t('mobileTravelPlanTitle'),
    [onlineCheckIn.name]: t('onlineCheckInTitle'),
    [lounge.name]: t('loungeTitle'),
    [platinum.name]: t('platinumTitle'),
    [qPass.name]: t('qPassTitle'),
    [seatMap.name]: t('seatMapTitle'),
    [simpleVisa.name]: t('simpleVisaTitle'),
    [sms.name]: t('smsTitle'),
    [travelDocsPost.name]: t('travelDocsPostTitle'),
    [travelInsuranceCoverGenius.name]: t('travelInsuranceCoverGeniusTitle'),
    [travelInsuranceInsideEu.name]: t('travelInsuranceInsideEUTitle'),
    [travelInsuranceOutsideEu.name]: t('travelInsuranceOutsideEUTitle'),
    [tripCancellationProtection.name]: t('tripCancellationProtectionTitle'),
  };
};

export type ProductCartNamesType = ReturnType<typeof useProductCartNames>;
